import React from 'react'
import {Card, Col} from 'react-bootstrap'

export default function Carousel(props) {
    return (
        <Col>
            <Card className={`${props.cCard} flashsal`}>
                <div className="header">{props.header}</div>
                  <img src={props.src} alt={props.alt} />
                  <div className="content-body">
                     {props.text}
                     <div className="muted">{props.potongan}</div>
                         {props.price}
                       <div className={props.progress}>
                         <div className="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100">
                            <p>{props.terjual}</p>
                         </div>
                       </div>
                     <div className="stok">{props.stok}</div>
                  </div>
                <div className={`${props.cProduk} flash-footer`}><a href="https://www.whatsapp.com/" target={`_blank`}>Bagikan Produk</a></div>
            </Card>
       </Col>
    )
}
